import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const apiUrl = environment.backendUrl;

@Injectable({
  providedIn: 'root',
})
export class DemoService {
  private http = inject(HttpClient);

  reserve(date: string) {
    const url = `${apiUrl}/demo/reserve`;
    return this.http.post(url, { date });
  }
}
